module.exports = __webpack_public_path__ + "img/step_1.4ced1e83.png";